/**
 * Where the online-order app lives: '' on order.chain29.com / online.chain29.com
 * (the subdomain IS the app), '/pwa/order' or '/order' with path routing
 * (localhost, *.ondigitalocean.app, chain29.com, app.chain29.com).
 * Same subdomain rule as App.js getSubdomain().
 */
export function orderBase() {
  const host = window.location.hostname;
  const local = host.includes('localhost') || host.includes('ondigitalocean.app');
  const parts = host.split('.');
  const sub = parts.length >= 3 ? parts[0].toLowerCase() : null;
  if (!local && (sub === 'order' || sub === 'online')) return '';
  return window.location.pathname.startsWith('/pwa/order') ? '/pwa/order' : '/order';
}

/** orderPath('confirmation/12?t=..') -> '/order/confirmation/12?t=..' or '/confirmation/12?t=..' */
export const orderPath = (route = '') => {
  const r = String(route).replace(/^\//, '');
  return `${orderBase()}${r ? `/${r}` : ''}` || '/';
};
